import { render, staticRenderFns } from "./ClientUpload.vue?vue&type=template&id=2bda4346&scoped=true"
import script from "./ClientUpload.vue?vue&type=script&lang=js"
export * from "./ClientUpload.vue?vue&type=script&lang=js"
import style0 from "./ClientUpload.vue?vue&type=style&index=0&id=2bda4346&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bda4346",
  null
  
)

export default component.exports